/* Tiny toast store.
 *
 * The api client surfaces 5xx as toasts so unexpected backend errors don't
 * silently disappear. Kept outside React context so anything (including
 * non-component code) can call `toast.error(...)`.
 */

import { create } from 'zustand';

export type ToastKind = 'info' | 'error' | 'success';

export interface ToastItem {
  id: number;
  kind: ToastKind;
  text: string;
}

interface ToastStore {
  items: ToastItem[];
  push: (kind: ToastKind, text: string) => void;
  dismiss: (id: number) => void;
}

let nextId = 1;

export const useToasts = create<ToastStore>((set) => ({
  items: [],
  push: (kind, text) => {
    const id = nextId++;
    set((s) => ({ items: [...s.items, { id, kind, text }] }));
    setTimeout(() => {
      set((s) => ({ items: s.items.filter((t) => t.id !== id) }));
    }, 4500);
  },
  dismiss: (id) => set((s) => ({ items: s.items.filter((t) => t.id !== id) })),
}));

export const toast = {
  info: (t: string) => useToasts.getState().push('info', t),
  error: (t: string) => useToasts.getState().push('error', t),
  success: (t: string) => useToasts.getState().push('success', t),
};
